import React from "react";
import PropTypes from "prop-types";
import { useStyles } from "../../assets/jss/ContentEngagementTab";
import CustomTabs from "../CustomComponents/CustomTabs/CustomTabs";
import CustomTab from "../CustomComponents/CustomTab/CustomTab";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import ContentEngagementTabList from "../ContentEngagementTabList/ContentEngagementTabList";
import { useTranslation } from "react-i18next";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <CustomBox p={3}>{children}</CustomBox>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    className:PropTypes.any,
};
const ContentEngagementTab = (props) => {
    const { t } = useTranslation();
    const { userId, isExpanded } = props;
    const classes = useStyles();
    const [tabValue, setTabValue] = React.useState(0);
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <>
            <CustomTabs
                className={classes.tabs}
                value={tabValue}
                onChange={handleTabChange}
                aria-label="Driver Tab data"
            >
                <CustomTab className={classes.tab} label={t("ACTIVE")} {...a11yProps(0)} />
                <CustomTab
                    className={classes.tab}
                    label={t("COMPLETED")}
                    {...a11yProps(1)}
                />
            </CustomTabs>
            <TabPanel className={classes.tabPanel} value={tabValue} index={0}>
                {isExpanded && (
                    <ContentEngagementTabList contentType="ACTIVE" userId={userId} {...props} />
                )}
            </TabPanel>
            <TabPanel className={classes.tabPanel} value={tabValue} index={1}>
                {isExpanded && (
                    <ContentEngagementTabList contentType="COMPLETED" userId={userId} {...props} />
                )}
            </TabPanel>
        </>
    );
};

export default ContentEngagementTab;
